<template>
  <el-dialog v-model="isVisible" title="Profile" width="90%" @close="close">
    <ProfileForm goBackOnSave @go-back="onGoBack" />
  </el-dialog>
</template>
<script lang="ts">
import { defineComponent, ref, watch } from 'vue'
import ProfileForm from '@/components/Profile/ProfileForm.vue'

export default defineComponent({
  name: 'Modal',
  components: {
    ProfileForm
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const isVisible = ref(props.visible)
    const withLoader = ref(props.loading)

    const close = () => {
      context.emit('close')
    }

    const onGoBack = () => {
      close()
      context.emit('go-back')
    }

    watch(
      (_: any) => props.visible,
      (val: any) => {
        isVisible.value = val
      }
    )
    watch(
      (_: any) => props.loading,
      (val: any) => {
        withLoader.value = val
      }
    )

    return {
      isVisible,
      close,
      withLoader,
      onGoBack
    }
  }
})
</script>

<style lang="scss" scoped>
.el-select {
  width: 100%;
}
</style>
